/**
 * A paperclip, drawn rather than typed.
 *
 * THE EMOJI DOES NOT WORK. U+1F4CE was the first attempt and it renders as a
 * thin vertical squiggle in some fonts -- visible in `preview/shots`, invisible
 * to every test, because jsdom has no fonts and no layout. An inline SVG looks
 * the same on every machine and inherits the text colour.
 *
 * IT LIVES HERE BECAUSE TWO TABLES NOW USE IT. It was defined inside
 * StatementMonths; the reconciliation History table wants the same mark for the
 * same thing, and a second copy is the drift CLAUDE.md's rule about derived
 * things is about -- two paperclips at two sizes, or one that keeps its
 * `aria-hidden` and one that does not, saying the same thing in two voices.
 */
export function PaperclipIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  );
}
